module.exports = __webpack_public_path__ + "static/img/9.dbf6f62.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/sp/9.png
// module id = 9Oik
// module chunks = 0